import { customHtml } from '@yola/ws-sdk';

const { fieldNames } = customHtml.constants;

export default {
  BUSINESS_LOGO: 'businessLogo',
  SITE_NAME: 'siteName',
  FAVICON: 'favicon',
  BUSINESS_NAME: 'businessName',
  BUSINESS_CATEGORY: 'businessCategory',
  BUSINESS_DESCRIPTION: 'businessDescription',
  PHONES: 'phones',
  ADDRESSES: 'addresses',
  EMAILS: 'emails',
  BUSINESS_HOURS: 'businessHours',
  IS_COOKIE_BANNER_ENABLED: 'isCookieBannerEnabled',
  PREVENT_INDEXING: 'preventIndexing',
  ...fieldNames,
};
